import { baseUrl } from "../utils/baseUrl";
import jwtInterceoptor from "./autorizacao/jwt-interceptor";

class ServicosProduto {
    create(produto) {
        return jwtInterceoptor.post(`${baseUrl}/produto`, produto)
    }
    listarTodosCategoria1(){
        return jwtInterceoptor.get(`${baseUrl}/produtos/categoria/1`)
    }
    listarTodosCategoria2(){
        return jwtInterceoptor.get(`${baseUrl}/produtos/categoria/2`)
    }
    listarTodosCategoria3(){
        return jwtInterceoptor.get(`${baseUrl}/produtos/categoria/3`)
    }
    listarTodosCategoria4(){
        return jwtInterceoptor.get(`${baseUrl}/produtos/categoria/4`)
    }
    editar(id, produto){
        return jwtInterceoptor.put(`${baseUrl}/produto/${id}`, produto)
    }
    deletar(id){
        return jwtInterceoptor.delete(`${baseUrl}/produto/${id}`)
    }
    listarUm(id){
        return jwtInterceoptor.get(`${baseUrl}/produto/${id}`)
    }
}

export default new ServicosProduto();